<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'采购订单详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                            :model="zy"
                            label-position="right"
                            ref="zy"
                            :rules="rules"
                            :inline="true"
                            class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="采购订单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.code" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="关联销售订单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.orderCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商名称" class="h-elformWrap-2">
                                                <el-input  v-model="zy.suserName" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                            <el-form-item v-if="fkshow" label="付款条件" class="h-elformWrap-2">
                                                <el-input  v-model="zy.dj" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.cdate" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.expectDate" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>产品信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input  v-model="zy.productCateName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.productDes" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品单价" class="h-elformWrap-2">
                                                <el-input  v-model="zy.unitPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品数量" class="h-elformWrap-2">
                                                <el-input  v-model="zy.count" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input  v-model="zy.totalPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="国家名称" class="h-elformWrap-2">
                                                <el-input  v-model="zy.ycountry" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="预测人" class="h-elformWrap-2">
                                                <el-input  v-model="zy.ycuname" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="预测单编号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.ycId" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input  v-model="zy.yremark" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="物流类型" class="h-elformWrap-2">
                                                <!--<dictname v-bind="" category="waybill_type"  :v="zy.waybillType"/>-->
                                                <el-input  v-model="zy.waybillTypeName" readonly> </el-input>
                                             </el-form-item>
                                            <el-form-item label="采购组" class="h-elformWrap-2">
                                                <mdmselect :showcode="true" :disabled="true" category="YLPurchaseGroup" class="h-tableInput" :v="zy.cgGroupCode"
                                                           v-model="zy.cgGroupCode"></mdmselect>
                                            </el-form-item>
                                            <el-form-item label="采购组织" class="h-elformWrap-2">
                                                <brselect :disabled="true" category="purchase_org_code" class="h-tableInput" :v="zy.purchaseOrgCode"
                                                          v-model="zy.purchaseOrgCode"></brselect>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receiver" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receverPhone" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receiveUnit" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2">
                                                <el-input  v-model="zy.detailAddress" :readonly="zy.status != 1"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2" v-if="fkshow">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>付款信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="付款状态" class="h-elformWrap-2">
                                                <el-input  v-model="zy.dj" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款金额" class="h-elformWrap-2">
                                                <el-input  v-model="zy.shdw" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="质保金" class="h-elformWrap-2">
                                                <el-input  v-model="zy.shdz" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.jsr" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.jsrsjh" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button v-if="zy.status == 1" class="h-btn h-bBtn h-bgblueQ2" @click="tijiao">提交修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data() {
            return {
                order:true,
                order1:false,
                //带线表单
                value: false,
                cgId: this.$route.query.cgId,
                zy: {},
                rules: {
                    formCon4: [
                        {required: true, message: '请输入客户全称', trigger: 'blur'}
                    ],
                    euName: [
                        {required: true, message: '请选择需求分类', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入需求说明', trigger: 'blur'}
                    ]
                },
                fkshow:false,
            }
        },
        methods: {
            cancel() {
                this.$router.go(-1);
                //this.$router.push("purchaselist");
            },
            tijiao() {
                var qr = {
                    cgId: this.zy.cgId,
                    suserName: this.zy.suserName,
                    expectDate: this.zy.expectDate,
                    yremark: this.zy.yremark,
                    receiver: this.zy.receiver,
                    receverPhone: this.zy.receverPhone,
                    receiveUnit: this.zy.receiveUnit,
                    detailAddress: this.zy.detailAddress,
                };
                this.$msg.confirm("确认提交修改?", () => {
                    ss.orderCgService.changeCgOrder(qr).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
        },
        mounted() {
            if (this.cgId != null) {
                //查看订单详情
                ss.orderCgService.selectById(this.cgId).then(rd => {
                    //初始化默认数据
                    this.zy = rd.obj
                })
            }
        }

    }
</script>
<style>
    .dingdan1.h-formLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }
    .dingdan1.h-formLine .el-form-item__content {
        width: 65%;
    }
    .dingdan1.h-formLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 0.6rem;
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;;
	}
</style>
